import { render, staticRenderFns } from "./HomeEmail.vue?vue&type=template&id=197e7a5b&scoped=true&"
var script = {}
import style0 from "./HomeEmail.vue?vue&type=style&index=0&id=197e7a5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197e7a5b",
  null
  
)

export default component.exports